var React = require('react');

function RedExclamation (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#F76B6B","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("circle",{"cx":"12","cy":"12","r":"9","key":0}),React.createElement("path",{"fill":"#F76B6B","d":"M11 5.76l1 8.222 1-8.221zM11 17a1 1 0 0 0 2 0 1 1 0 0 0-2 0z","key":1})]));
}

RedExclamation.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RedExclamation;

RedExclamation.default = RedExclamation;
